import { useSelector } from "react-redux";
import { rootReducersState } from "../reducers";

const useTimezone = () => {
  const timezone = useSelector(({ settings }: rootReducersState) => settings.timezone);

  return { timezone };
};

export default useTimezone;
